var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-solicitudes" },
    [
      _c("div", { staticClass: "ibox" }, [
        _c("div", { staticClass: "ibox-title dashboard-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0 dashboard-header-subtitle" }, [
            _vm._v(
              "\n                Sistema de Atención al Usuario - CAPREDENA | División de\n                Atención al Usuario\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-tools" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-light",
                attrs: { disabled: _vm.loading, title: "Regenerar datos fake" },
                on: { click: _vm.regenerateFakeData },
              },
              [
                _c("i", { staticClass: "fal fa-sync-alt" }),
                _vm._v(" Regenerar Datos\n                "),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("PeriodSelector", {
        attrs: { period: _vm.selectedPeriod },
        on: {
          "period-changed": _vm.onPeriodChanged,
          "custom-period-applied": _vm.onCustomPeriodApplied,
        },
      }),
      _vm._v(" "),
      _c("KPICards", { attrs: { kpis: _vm.dashboardData.kpis } }),
      _vm._v(" "),
      _c("RealTimeAgentStatus"),
      _vm._v(" "),
      _c("ThemeAnalysisChart", {
        attrs: { "tema-analisis": _vm.dashboardData.temaAnalisis },
      }),
      _vm._v(" "),
      _c("OverdueRequestsChart", {
        attrs: { "overdue-data": _vm.dashboardData.temaVencidas },
      }),
      _vm._v(" "),
      _c("DemographicsChart", {
        attrs: { "demographics-data": _vm.dashboardData.demographicsData },
      }),
      _vm._v(" "),
      _c("AgentPerformance", {
        attrs: {
          "agente-performance": _vm.dashboardData.agentePerformance,
          period: _vm.selectedPeriod,
          from:
            _vm.customDates && _vm.selectedPeriod === "personalizado"
              ? _vm.customDates.startDate
              : null,
          to:
            _vm.customDates && _vm.selectedPeriod === "personalizado"
              ? _vm.customDates.endDate
              : null,
        },
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading-overlay" }, [_vm._m(1)])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("i", { staticClass: "fal fa-chart-line" }),
      _vm._v(
        " Dashboard de Gestión de\n                Solicitudes\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-content" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" }),
      _vm._v(" "),
      _c("p", [_vm._v("Cargando datos...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }